export default "__VITE_ASSET__08ad85cc__"